import React from "react";
import Homefooter from "../components/Homefooter";
import Mybtable from "../components/Mybtable";
import Navbar from "../components/Navbar";

function Mybookings() {
    return (
        <>
            <Navbar />
            <Mybtable />
            <Homefooter />
        </>
    );
}

export default Mybookings